export const getHeaders = (token: string) => ({
  token: token,
});
